// Copy shown when an entity type has no custom fields defined yet.
// Kept dependency-free (no design-system imports) so it is unit-testable in isolation.
export const getEntityText = (entityType: string): string => {
	switch (entityType) {
		case 'PROJECT':
			return 'No custom fields associated with projects.';
		case 'PHASE':
			return 'No custom fields associated with phases.';
		case 'TASK':
			return 'No custom fields associated with tasks.';
		case 'TIME_REG':
			return 'No custom fields associated with time entries.';
		case 'TICKET':
			return 'No custom fields associated with tickets.';
		default:
			return 'No custom fields associated with this entity type.';
	}
};
